import { Logo } from "../Logo";

export function DashboardShimmerLoader() {
  return (
    <div>
      {/* Mobile top bar */}
      <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-xs sm:px-6 lg:hidden border-b border-gray-200">
        <div className="h-5 w-5 rounded shimmer" />
        <div className="flex-1 flex items-center gap-2">
          <Logo className="h-6 w-auto" />
          <span
            className="text-2xl font-semibold text-gray-900"
            style={{ fontFamily: "'Questrial', sans-serif" }}
          >
            fluvo
          </span>
        </div>
        <div className="size-8 rounded-full shimmer" />
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
        <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white">
          {/* Logo */}
          <div className="flex h-16 shrink-0 items-center px-4">
            <div className="flex items-center gap-2">
              <Logo className="h-4 w-auto" />
              <span
                className="text-2xl font-semibold text-gray-900"
                style={{ fontFamily: "'Questrial', sans-serif" }}
              >
                fluvo
              </span>
            </div>
          </div>

          {/* Sidebar nav */}
          <nav className="flex flex-1 flex-col px-4 mt-4">
            <ul className="flex flex-1 flex-col gap-y-7">
              <li>
                <div className="text-xs/6 font-semibold text-gray-400">
                  Stakeholders
                </div>
                <ul className="-mx-2 mt-2 space-y-1">
                  {[1, 2, 3].map((i) => (
                    <li key={i}>
                      <div className="flex w-full gap-x-3 rounded-md px-3 py-2.5">
                        <div className="size-6 shrink-0 rounded-lg shimmer" />
                        <div
                          className="h-5 rounded-full shimmer"
                          style={{ width: `${70 + i * 20}px` }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </li>

              {/* Bottom section */}
              <li className="-mx-4 mt-auto flex flex-col">
                <div className="flex items-center gap-x-4 px-4 py-3">
                  <div className="size-8 shrink-0 rounded-full shimmer" />
                  <div className="h-4 w-20 rounded-full shimmer" />
                </div>
                <div className="flex items-center gap-x-4 px-4 py-3 border-t border-gray-100">
                  <div className="size-8 shrink-0 rounded-full shimmer" />
                  <div className="flex flex-col gap-1">
                    <div className="h-4 w-24 rounded-full shimmer" />
                    <div className="h-3 w-16 rounded-full shimmer" />
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div
        className="lg:pl-72"
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          minHeight: 0,
        }}
      >
        <main
          className="bg-white"
          style={{ flex: 1, minWidth: 0, overflowY: "auto" }}
        >
          {/* Goals header */}
          <div className="px-4 py-6 sm:px-6 lg:px-8 flex items-center justify-between">
            <div className="h-6 w-28 rounded-full shimmer" />
            <div className="h-9 w-28 rounded-full shimmer" />
          </div>
          <div className="border-b border-gray-200" />

          {/* Goal list items */}
          <ul className="divide-y divide-gray-100">
            {[1, 2, 3, 4].map((i) => (
              <li key={i} className="px-6 py-4">
                <div className="flex items-center gap-4">
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full shimmer" />
                        <div
                          className="h-4 rounded-full shimmer"
                          style={{ width: `${140 + i * 30}px` }}
                        />
                      </div>
                      <div className="h-3 w-20 rounded-full shimmer ml-4" />
                    </div>
                  </div>
                  <div className="h-8 w-20 rounded-md shimmer" />
                </div>
              </li>
            ))}
          </ul>
        </main>
      </div>
    </div>
  );
}
